export default class StatisticsCtrl {
    constructor($scope, $timeout, $q, $rootScope, $stateParams, $window, Campaign, AbTest, SideMenu, $state, $filter, ChartData, Translate, Statistics, Events, Google, Event) {
        SideMenu.setActive('campaign');

        this._stateParams = $stateParams;
        this._window = $window;
        this._state = $state;
        this._timeout = $timeout;
        this._filter = $filter;
        this._scope = $scope;
        this._rootScope = $rootScope;
        this._q = $q;

        this.campaignRepo = Campaign;
        this.abTestRepository = AbTest;
        this.statisticRepo = Statistics;
        this.chartDataRepo = ChartData;
        this.translateRepo = Translate;
        this.eventsRepo = Events;
        this.eventRepo = Event;
        this.googleRepo = Google;

        this.stateToTypeMap = {
            'campaign.transactionshow': {
                'type': 'transactional',
                'exportType': 'statistic-export'
            },
            'campaign.show': {
                'type': 'campaign',
                'exportType': 'statistic-export'
            },
            'automation.statistics': {
                'type': 'automation',
                'exportType': 'statistic-automation-export'
            },
            'event.campaignStatistics': {
                'type': 'campaign',
                'exportType': 'statistic-export'
            },
            'event.automationStatistics': {
                'type': 'automation',
                'exportType': 'statistic-automation-export'
            }
        };
        this.typeToTranslation = {
            open: 'STATISTIC:EXPORT:OPENED_DESC',
            link: 'STATISTIC:EXPORT:CLICKED_DESC',
            browser: 'STATISTIC:EXPORT:IN_BROWSER_DESC',
            received: 'STATISTIC:EXPORT:RECEIVED_DESC',
            unsubscribed: 'STATISTIC:EXPORT:UNSUBSCRIBED_DESC',
            hard_bounce: 'STATISTIC:EXPORT:HARD_BOUNCE_DESC',
            soft_bounce: 'STATISTIC:EXPORT:SOFT_BOUNCE_DESC',
            spam: 'STATISTIC:EXPORT:SPAM_DESC'
        };

        this.dispatcherType = this.stateToTypeMap[this._state.current.name].type;
        this.dispatcherExportType = this.stateToTypeMap[this._state.current.name].exportType;
        this.chartOptions = this.chartDataRepo.getDefaultOptions();

        if (this._state.current.name === 'event.campaignStatistics' || this._state.current.name === 'event.automationStatistics') {
            this.isEventStatistics = true;
            SideMenu.setActive('event');
        } else if (this.dispatcherType === 'automation') {
            SideMenu.setActive('automation');
        } else {
            SideMenu.setActive('campaign');
        }

        this.status = this._stateParams.folder;
        this.messageType = this._stateParams.messageType ? this._stateParams.messageType : 'email';
        this.devices = [];
        this.analytics = [];

        let showNumbers = this._window.localStorage.getItem('settings.statistics.showNumbers');

        this.settings = {
            showDeviceStats: false,
            currentPage: 1,
            selection: this.messageType === 'email' ? 'unique' : 'total',
            bouncedSelection: 'soft',
            unsubscribedSelection: 'user',
            showNumbers: showNumbers ? showNumbers : true,
            messageType: this.messageType
        };

        this.profiles = this.googleRepo.profiles;

        this._scope.$watch(() => this.status, () => {
            this.settings.showDeviceStats = false;

            //prevent request if it is google
            if (this.status !== 'google') {
                this.getStatistics();

                if (this.status === 'link') {
                    this.getLinks();
                }
            } else {
                if (this.messageType == "email") {
                    if (!this.utm) {
                        this.getUtm().then((res) => {
                            this.utm = res.utm;
                            this.getGoogleTab();
                        });
                    } else {
                        this.getGoogleTab();
                    }
                }
            }
        });

        this._scope.$watchGroup(['settings.unsubscribedSelection', 'settings.bouncedSelection'], () => {
            if (this.initialized) {
                this.settings.showDeviceStats ? this.getDeviceStats() : this.getStatistics();
            }
        });

        this._scope.$watch('settings.selection', () => {
            if (this.initialized) {
                this.settings.showDeviceStats ? this.getDeviceStats() : this.getStatistics();
            }
        });

        this._scope.$watch('settings.showDeviceStats', () => {
            if (this.initialized) {
                this.busy = true;
                this.settings.showDeviceStats ? this.getDeviceStats() : this.getStatistics();
            }
        });

        this._scope.$watch('settings.showNumbers', (newVal, oldVal) => {
            if (newVal !== oldVal) {
                this.generateCharts();
            }
        });

        this._scope.$on('goals:got', (event, goals) => {
            angular.forEach(goals, (goal) => {
                this.goals = goal;
            });
            let dates = moment(this.settings.startDate).format('YYYY-MM-DD') + ':' + moment(this.settings.endDate).format('YYYY-MM-DD');
            this.statisticRepo.storeGoals(this.goals, this.utm, dates, this.analytics.currentProfile, this._stateParams.id);
        });

        this._scope.$watch(() => this.analytics.currentProfile, (newVal, oldVal) => {
            if (newVal !== oldVal && newVal !== 'none' && newVal !== undefined) {
                this.getGoogleData();
            }
        });

        let blockStatsListener = this._rootScope.$on('statistics:updateWithCollections', (event, collections) => {
            this.settings.activeCollections = collections;
            this.subscribers = [];

            this.getCounts();
            this.getStatistics();
        });

        let updateStatisticsListener = this._rootScope.$on('statistics:updateStatistics', () => {
            this.getStatistics();
        });

        this._scope.$on('$destroy', blockStatsListener);
        this._scope.$on('$destroy', updateStatisticsListener);

        // Check whether an export is running or has been finished.
        this._timeout(() => {
            this.statisticRepo.exportProgress(this._stateParams.id, this.dispatcherType).then((exportProgress) => {
                this.exportData = exportProgress;

                if (exportProgress && exportProgress.meta !== null) {
                    this.exportActive = true;
                    this._rootScope.$emit('progress:start', this.dispatcherExportType, this.dispatcherType);
                }
            });
        }, 2000);

        this._scope.$on('profiles:got', () => {
            this.profiles = this.watchProfiles();
        });

        this.getCounts();
    }



    formatStatisticType() {
        if (this.status === 'bounced') {
            return this.settings.bouncedSelection + '_bounce';
        } else if (this.status === 'unsubscribed') {
            return this.settings.unsubscribedSelection === 'user' ? 'unsubscribed' : 'spam';
        } else {
            return this.status;
        }
    };

    getUtm() {
        if (this.dispatcherType === 'automation') {
            return this.statisticRepo.getEmailUtm(this._stateParams.id);
        } else {
            return this.statisticRepo.getCampaignUtm(this._stateParams.id)
        }
    };

    setStatus(status) {
        this._state.go(this._state.current.name, { id: this._stateParams.id, folder: status });
    };

    goToGoogleTab() {
        if (this.utm) {
            this.setStatus('google');
        } else {
            this.eventsRepo.flashEvent('error', this._filter('translate')('STATISTIC:GOOGLE:NO_UTM'));
        }
    };

    toEvent() {
        var statusIdToNameMap = {
            1: 'draft',
            2: 'current',
            3: 'completed',
            4: 'scheduled',
            5: 'cancelled'
        };

        this.eventRepo.find(this._stateParams.eventId).then((event) => {
            this._state.go('event.folder', { folder: statusIdToNameMap[event.data.event_status_id]});
        });
    };

    getStatistics() {
        let status = this.formatStatisticType();

        this.statisticRepo.getStatistics(this._stateParams.id, this.dispatcherType, status, this.settings).then((results) => {
            this._rootScope.$emit('progress:start');

            this.dispatcher = results.dispatcher;
            this.statistics = results.stats;
            this.settings.startDate = moment(results.dates.startDate, 'YYYY-MM-DD');
            this.settings.endDate = moment(results.dates.endDate, 'YYYY-MM-DD');
            this.busy = false;

            if (this.messageType == "email") {
                this.getUtm().then((res) => {
                    this.utm = res.utm;
                });
            }

            this.generateCharts();
            
            if (! this.calendar) {
                this.initialized = true;
                this.initCalendar(this.settings.startDate, this.settings.endDate);
            }
        });
    };

    getCounts() {
        this.uniqueCounts = [];
        this.totalCounts = [];

        this.statisticRepo.getStatusCounts(this._stateParams.id, this.dispatcherType, this.settings).then((response) => {

            angular.forEach(response, (countsByType) => {
                this.uniqueCounts[countsByType.type] = countsByType.uniqueCount;
                this.totalCounts[countsByType.type] = countsByType.totalCount;
            });
        });
    };

    initCalendar(startDate, endDate) {
        let earliestDate = moment();
        earliestDate.subtract(1, 'year'); // Max one year back.

        this.calendar = new Calendar({
            element: $('.daterange--double'),
            earliest_date: earliestDate,
            latest_date: moment(),
            start_date: startDate,
            end_date: endDate,
            same_day_range: true,
            days_array: ['Mo','Tu','We','Th','Fr','Sa','Su'],
            callback: () => {
                this.getStatisticsByPeriod(moment(this.calendar.start_date), moment(this.calendar.end_date));
                this._rootScope.$emit("refreshSubscribers", {startDate: moment(this.calendar.start_date), endDate: moment(this.calendar.end_date)});
            }
        });
    };

    generateCharts() {
        this.chartDataRepo.clear();
        var dataPoints = [];

        if (! this.settings.showNumbers) { // Show percentage
            this.chartOptions.scaleLabel = '<%= Number(value) + " %" %>';
            var totalSent = this.totalCounts['received'];
            
            angular.forEach(this.statistics, (dateCount) => {
                var percentageOfSent = ((dateCount.count / totalSent) * 100).toFixed(1);
                dataPoints.push({ count: percentageOfSent, created_at: dateCount.created_at });
            });
        } else {
            this.chartOptions.scaleLabel = '<%= Number(value) %>';
            dataPoints = this.statistics;
        }

        this.chartData = this.chartDataRepo.addStatisticsData(
            this.dispatcher.name,
            dataPoints,
            this.settings,
            "rgba(52,184,128,1)", // Chart color.
            false, // Never hide.
            ! this.settings.showNumbers
        );

        this.devicesData = this.chartDataRepo.deviceStatisticsData(
            this.devices,
            this.settings.startDate,
            this.settings.endDate
        );

        // Manually trigger digest
        this._timeout(() => {
            this._scope.$apply();
        });
    };

    getLinks() {
        this.statisticRepo.getLinks(this._stateParams.id, this.dispatcherType, this.settings).then((response) => {
            this.links = response;
        });
    };



    percentage(number, totalSent) {
        if (! number || ! totalSent || totalSent === 0 || number === 0) {
            return 0;
        }

        return (parseFloat(number / totalSent) * 100).toFixed(1) || 0;
    };

    getStatisticsByPeriod(startDate, endDate) {
        if (startDate !== this.settings.startDate || endDate !== this.settings.endDate) {

            this.settings.startDate = startDate;
            this.settings.endDate = endDate;

            if (this.status !== 'google') {
                this.getStatistics();
            } else if (this.analytics.currentProfile) {
                this.getGoogleData();
            }

            this.getCounts(this.settings.startDate, this.settings.endDate);
            this.getLinks();
            this._rootScope.$emit('statistic:dates:changed');
        }
    };

    getDeviceStats() {
        let status = this.formatStatisticType();
        this.settings.showNumbers = true;

        this.statisticRepo.getDeviceStats(this._stateParams.id, this.dispatcherType, status, this.settings).then((response) => {
            this.devices = response;
            this.generateCharts();
            this.busy = false;
        });
    };


    
    hasStatistics() {
        if (this.initialized) {
            let hasDataPoints = this.settings.showDeviceStats ? this.devices.length : this.statistics.length;

            if (this.status === 'google') {
                return false;
            }

            return hasDataPoints && this.statistics.length > 0 && ! this.busy;
        }
    };

    watchProfiles() {
        return this.googleRepo.getProfiles();
    };
   
    getGoogleTab() {
        if (! this.currentUser) {
            this.googleRepo.auth();
        }
        if (this.analytics.currentProfile) {
            this.getGoogleData();
        }
    };

    getGoogleData() {
        if (! this.calendar) {
            this.initCalendar(this.settings.startDate, this.settings.endDate);
        }
        this.googleRepo.setDates(this.calendar.start_date, this.calendar.end_date);
        var dates = moment(this.settings.startDate).format('YYYY-MM-DD') + ':' + moment(this.settings.endDate).format('YYYY-MM-DD');
        this.statisticRepo.getCachedGoal(this.utm, dates, this.analytics.currentProfile, this._stateParams.id).then((result) => {
            if (result.goals) {
                this.goals = result.goals;
            } else {
                this.googleRepo.setUtms([this.utm]);
                this.googleRepo.getGoogleData(this.analytics.currentProfile, this.utm);
            }
        });
    };

    toggleChartAxis() {
        this.settings.showNumbers = ! this.settings.showNumbers;
        this._window.localStorage.setItem('settings.statistics.showNumbers', this.settings.showNumbers);
    };

    printExportMetaData() {
        let prefix = this.exportData.meta.hasStatistic ? 'GLOBAL:HAS' : 'STATISTIC:EXPORT:HAS_NOT';
        let type = this.typeToTranslation[this.exportData.meta.type];
        return this._filter('translate')(prefix).toLowerCase() + ' ' + this._filter('translate')(type).toLowerCase();
    };

    downloadExport() {
        this._window.open(this.exportData.url);
    };
}